import serverConnection from '../common/server-connection.js';

export default function() {
  var topSlider = tns({
      container: '.home-banner-slider',
      items: 1,
      slideBy: 'page',
      mouseDrag: true,
      nav: false,
      autoplay: false,
      controlsText: ["<span></span>","<span></span>"]
    });

  var activitiesSlider = tns({
      container: '.activities-slider',
      items: 1,
      mouseDrag: true,
      nav: false,
      autoplay: false,
      slideBy: 1,
      controlsText: ["<span></span>","<span></span>"],
      responsive: {
        320: {
          items: 1,
        },
        734: {
          items: 3,
        }
      }
    });

  var mizoneSlider = tns({
      container: '.mi-zone-slider',
      items: 1,
      speed: 1000,
      mouseDrag: false,
      nav: false,
      autoplay: true,
      autoplayButtonOutput: false,
      controls: false,
      slideBy: 1
    });

  var frontCharSlider = tns({
      container: '.front-characters-slider',
      items: 1,
      speed: 1000,
      mouseDrag: true,
      nav: false,
      autoplay: false,
      autoplayButtonOutput: false,
      controlsText: ["<span></span>","<span></span>"],
      slideBy: 1,
      startIndex: 3
    });

  var frontIndex = frontCharSlider.getInfo().index;

  frontCharSlider.events.on('indexChanged', function(info){
    if (info.index > frontIndex) {
      backCharSlider.goTo('next');
    } else {
      backCharSlider.goTo('prev');
    }
    // backCharSlider.goTo(info.index);
    frontIndex = info.index;
  });

  var backCharSlider = tns({
      container: '.back-characters-slider',
      items: 7,
      speed: 1000,
      mouseDrag: true,
      nav: false,
      autoplay: false,
      autoplayButtonOutput: false,
      controls: false,
      slideBy: 1,
      gutter: 20,
      responsive: { 
        320: {
          items: 3,
        },
        520: {
          items: 7,
        },
        985: {
          items: 7,
        }
      }
    });

  var dpickSlider = tns({
      container: '.dpick-slider',
      items: 4,
      mouseDrag: false,
      nav: false,
      autoplay: false,
      slideBy: 4,
      controlsText: ["<span></span>","<span></span>"],
      responsive: {
        320: {
          items: 1,
          slideBy: 1,
        },
        734: {
          items: 2,
          slideBy: 2,
        },
        985: {
          items: 4,
          slideBy: 4,
        }
      }
  })

  $('.mi-zone-slider-controller .slide-control').on('click', function(e){
    var toSlide = $(e.target).data("slide");
    mizoneSlider.goTo(toSlide*1);
  });

  $('.icon-heart').on('click', function(e){
    var id = $(e.target).data('id');
    var that = this;
    var url = site_lang+"/dpicks/"+id;
    var method = "POST";
    var data = {};

    serverConnection(data, url, method, function(res, xhr){
      $('.icon-heart[data-id="'+id+'"]').addClass('selected');
      $('.icon-heart[data-id="'+id+'"]').prev().html( res.dpick.like );
    });

  })
  console.log("called")
}


// WEBPACK FOOTER //
// app/javascript/src/javascripts/page/home.js